import { Box } from '@material-ui/core'
import React from 'react'
import { useSelector } from 'react-redux'
import { HTMLTextComponent } from '../../../../libs/shared-components'
import { Typography } from '../../../../ui'
import { dashboardCardStyles } from '../../../_styles/dashboardCardStyles'
import { selectNetworkSettings } from '../../../network/model'
import { CarouselItem, DashboardCard } from '../../../network/type'

export const CarouselCard = (props: {
  button: DashboardCard
  buttonAction: (path: string, id?: string, type?: number) => void
  startWorkflows: (ids: string[] | undefined) => void
  xl: boolean
}) => {
  const { button, xl, buttonAction, startWorkflows } = props
  const networkSettings = useSelector(selectNetworkSettings)
  const radius = networkSettings?.buttonStyle === 0 ? 8 : 24
  const classes = dashboardCardStyles({ radius })

  const handleClick = (item: CarouselItem | undefined) => {
    if (!item) return

    if (item.itemButtonAction.value === 'Workflow') {
      startWorkflows(item.workflowIds)
    } else if (item.itemButtonAction.value === 'RedirectToUrl') {
      if (!item.itemRedirectUrl) return
      buttonAction(item.itemButtonAction.value, item.itemRedirectUrl)
    } else if (item.itemButtonAction.value === 'Resources') {
      if (!item.link) {
        buttonAction(item.itemButtonAction.value)
      } else {
        buttonAction(
          item.itemButtonAction.value,
          item.link.itemResourceId,
          item.link.type
        )
      }
    } else if (item.itemButtonAction.value) {
      buttonAction(item.itemButtonAction.value)
    }
  }

  return (
    <Box className={classes.largeCardWrapper}>
      <div className={classes.largeCard}>
        <Typography className={classes.topTitle}>
          <HTMLTextComponent HTMLString={button.cardTitle} />
        </Typography>
        {button.carouselItems?.[0] && xl && (
          <>
            <Box
              className={classes.carouselImageContainer}
              style={{
                cursor: 'pointer',
                backgroundImage: `url(${button.carouselItems[0].itemImageUrl})`,
              }}
              onClick={
                button.carouselItems && button.carouselItems.length > 0
                  ? () => handleClick(button.carouselItems?.[0])
                  : undefined
              }
            />
            <Typography
              className={classes.dashboardButtonBody}
              style={{ marginTop: 16, fontWeight: 600 }}
            >
              <HTMLTextComponent
                HTMLString={button.carouselItems[0].itemTitle}
              />
            </Typography>
          </>
        )}
        <Box className={classes.secondaryItems}>
          {button.carouselItems &&
            button.carouselItems.length > 0 &&
            button.carouselItems.map((item, i) => (
              <React.Fragment key={`${item.itemButtonAction?._id}-${i}`}>
                {i === 0 && xl ? null : (
                  <Box className={classes.itemContainer}>
                    <Box
                      className={classes.smallImageContainer}
                      style={{
                        backgroundImage: `url(${item.itemImageUrl})`,
                      }}
                      onClick={() => handleClick(item)}
                    />
                    <Typography className={classes.secondaryText}>
                      <HTMLTextComponent HTMLString={item.itemTitle} />
                    </Typography>
                  </Box>
                )}
              </React.Fragment>
            ))}
        </Box>
      </div>
    </Box>
  )
}
